var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLocationSmall = function SvgLocationSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20 8.956c0 4.244-4.923 10.33-7.045 11.758a1.735 1.735 0 01-1.91 0C8.923 19.286 4 13.2 4 8.956 4 5.114 7.582 2 12 2s8 3.114 8 6.956z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 13a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLocationSmall;